var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 114,
    viewBox: "0 0 128 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.4164 32.3766C88.781 39.0208 102.01 38.5462 106.934 43.2328C111.917 47.9193 108.536 57.767 105.332 67.6147C102.069 77.403 98.9253 87.2507 92.1624 93.4797C85.3996 99.7086 75.0773 102.319 66.3567 100.124C57.5769 97.9883 50.3988 91.0474 42.746 85.1151C35.1527 79.1827 27.0253 74.2589 24.5338 67.3181C21.9829 60.3772 25.0677 51.4787 29.4576 44.5972C33.9069 37.7157 39.7206 32.8512 45.8309 25.4358C51.9412 18.0203 58.3481 7.99469 63.3906 9.89304C68.3737 11.8507 71.9925 25.6731 80.4164 32.3766Z",
    fill: "#F8D177",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8911 60.7872C86.5296 64.8719 77.3809 59.0319 75.5131 57.7872C77.9681 59.4614 93.0875 70.0088 89.5985 73.4978C87.3199 75.7764 82.8318 72.6012 79.6099 69.701C82.3799 72.7879 85.3581 76.9794 83.3381 78.9994C81.1451 81.1924 75.4868 76.9924 71.7184 73.7062C74.6328 76.6492 77.9684 80.6553 76.1291 82.0348C73.0937 84.3113 60.5728 76.3434 60.5728 76.3434C51.6012 75.4501 37.5626 75.8295 22.1961 85.8842L18.5916 45.0964C34.5272 44.3376 40.9865 41.9744 63.9876 46.3692C73.5442 48.1952 89.4088 56.2341 87.8911 60.7872Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5916 45.0964C34.5272 44.3376 40.9865 41.9744 63.9876 46.3692C73.5442 48.1952 89.4088 56.2341 87.8911 60.7872C86.3734 65.3402 75.1805 57.5621 75.1805 57.5621C75.1805 57.5621 93.3927 69.7036 89.5985 73.4978C85.8043 77.292 75.8841 65.9646 75.8841 65.9646C75.8841 65.9646 86.7529 75.5846 83.3381 78.9994C79.9233 82.4142 68.106 70.3279 68.106 70.3279C68.106 70.3279 79.1645 79.7582 76.1291 82.0347C73.0937 84.3113 60.5728 76.3434 60.5728 76.3434C51.6012 75.4501 37.5626 75.8295 22.1961 85.8842",
    stroke: "#215585",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7561 44.8047C26.1138 55.7152 27.4732 78.3411 30.0488 81.5606",
    stroke: "#215585",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.642 17.6236C120.318 26.1825 119.012 39.1374 109.969 47.7788C105.575 51.9778 100.623 54.078 95.7748 54.135C90.9351 54.1919 86.0348 52.2158 81.7186 47.9581C73.0736 39.4304 71.9613 26.9271 80.0319 18.2477C88.4197 9.22714 102.838 8.93903 111.642 17.6236Z",
    stroke: "#964BC4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.282 44.8794L83.338 47.894L66.0042 65.4661C65.1718 66.31 63.8128 66.3193 62.9689 65.4868C62.125 64.6544 62.1157 63.2954 62.9482 62.4515L80.282 44.8794Z",
    fill: "#964BC4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5996 51.3891C73.0563 49.9123 75.4345 49.896 76.9113 51.3528C78.3881 52.8096 78.4044 55.1878 76.9476 56.6646L62.6284 71.1807C61.1716 72.6575 58.7934 72.6738 57.3166 71.217C55.8398 69.7602 55.8235 67.382 57.2803 65.9052L71.5996 51.3891Z",
    fill: "#964BC4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M107.821 21.5464C110.708 24.5665 111.89 28.3538 111.763 32.0682",
    stroke: "#964BC4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 110.955,
    cy: 35.9434,
    r: 1.07316,
    transform: "rotate(44.6088 110.955 35.9434)",
    fill: "#964BC4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8452 66.2095C75.4497 55.3959 57.6169 50.0841 57.6169 50.0841L57.8066 63.5535C57.8066 63.5535 60.9971 62.3897 63.1185 62.4152C65.5847 62.9844 69.6635 72.7545 71.8452 66.2095Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6169 50.0841C57.6169 50.0841 75.4497 55.3959 71.8452 66.2095C69.6635 72.7545 65.5847 62.9844 63.1185 62.4152C60.9971 62.3897 57.8066 63.5535 57.8066 63.5535",
    stroke: "#215585",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportImage);
export default __webpack_public_path__ + "static/media/ImportImage.d50b97e396afd41d75eeacda6284f19c.svg";
export { ForwardRef as ReactComponent };